import React, { ReactNode } from 'react'

import connectConditionalResults from '../../Connectors/statsConnector'
import { SearchContext } from '../../../types'

type PropTypes = {
  children: ReactNode
  nbHits: number
  hasResults: boolean
  contextValue: SearchContext
  allSearchResults: any
  isLastIndex: boolean
  setIsNoResults: () => void
  onSearchResults: (value: PropTypes) => void
  indexContextValue: {
    targetedIndex?: string
  }
  query?: string
}

const Results = (props: PropTypes) => {
  const { children, nbHits, onSearchResults }: PropTypes = props

  if (onSearchResults) {
    onSearchResults(props)
  }

  return nbHits ? children : null
}

const areEqual = (
  { allSearchResults, indexContextValue }: PropTypes,
  nextProps: PropTypes,
) => {
  // checking for individual search index
  if (allSearchResults?.hits || nextProps.allSearchResults?.hits) {
    return (
      JSON.stringify(allSearchResults?.hits) ===
      JSON.stringify(nextProps.allSearchResults?.hits)
    )
  }

  // checking for master search index
  const prevData = allSearchResults
    ? allSearchResults[indexContextValue?.targetedIndex || '']
    : ''

  const nextData = nextProps.allSearchResults
    ? nextProps.allSearchResults[
        nextProps.indexContextValue?.targetedIndex || ''
      ]
    : ''

  return JSON.stringify(prevData?.hits) === JSON.stringify(nextData?.hits)
}

// @ts-ignore
export default connectConditionalResults(React.memo(Results, areEqual))
